module.exports = __webpack_public_path__ + "img/img-a3202d62.3cb7d87d.png";